// @ts-nocheck
import React from 'react';
import WizardStepItem from './WizardStepItem';
import icons from '../../../../constants/icons';
import { useTranslation } from 'react-i18next';

export interface SelectCompanyStepProps {
  stepName?: string;
  currentUser: { companyId?: string };
  companies?: Array<{ id: string; companyName?: string; imageId?: string; colourHex?: string }>;
  handleCompanySelect: (value: string) => void;
}

export default function SelectCompanyStep({
  stepName,
  currentUser,
  companies,
  handleCompanySelect,
}: SelectCompanyStepProps) {
  const { t } = useTranslation();
  return (
    <>
      <h2 className="mb-4">{t('Who is this request for?')}</h2>
      <p>{t('Your company')}</p>
      {companies
        ? [...companies]
            ?.sort((a, b) => (a.companyName ?? '').localeCompare(b.companyName ?? ''))
            .filter((x) => x.id === currentUser.companyId)
            .map((company) => (
              <WizardStepItem
                key={company.id}
                id={company.id}
                typeIcon={icons.WIZARD_STAR as unknown as string}
                typeIconClassname="text-yellow"
                typeImageId={company.imageId}
                typeImageColourHex={company.colourHex}
                typeImageFallback={icons.WIZARD_STAR as unknown as string}
                title={company.companyName ?? ''}
                description=""
                icon={icons.WIZARD_NEXT}
                onClick={handleCompanySelect}
              />
            ))
        : ''}
      <p>{t('Request on behalf of another company')}</p>
      {companies
        ? [...companies]
            ?.sort((a, b) => (a.companyName ?? '').localeCompare(b.companyName ?? ''))
            .filter((x) => x.id !== currentUser.companyId)
            .map((company) => (
              <WizardStepItem
                key={company.id}
                id={company.id}
                typeIcon={icons.COMPANY as unknown as string}
                typeIconClassname="text-blue"
                typeImageId={company.imageId}
                typeImageColourHex={company.colourHex}
                typeImageFallback={icons.COMPANY as unknown as string}
                title={company.companyName ?? ''}
                description=""
                icon={icons.WIZARD_NEXT}
                onClick={handleCompanySelect}
              />
            ))
        : ''}
    </>
  );
}
